import * as Charts from './chart';

let frappe     = { };

frappe.NAME    = 'Frappe Charts';
frappe.VERSION = '1.5.2';

frappe         = Object.assign({ }, frappe, Charts);

export default frappe;